import { store } from 'redux/store';
import { setModal } from 'modules/_shared/redux/modalActions';

import operationTypes from 'constants/operationTypes';
import sizes from 'constants/sizes';

import AddPartnerModal from 'modules/_shared/components/Modals/AddPartnerModal';
import Constitution from 'modules/_shared/components/Modals/Constitution';
import CapitalIncrease from 'modules/_shared/components/Modals/CapitalIncrease';
import CapitalDecreaseModal from 'modules/_shared/components/Modals/CapitalDecreaseModal';
import SharesTransferModal from 'modules/_shared/components/Modals/SharesTransfer';
import Reclassification from 'modules/_shared/components/Modals/ReclassificationModal';
import DividendsDistribution from 'modules/_shared/components/Modals/DividendsDistribution';
import RollbackOperationModal from 'modules/_shared/components/Modals/RollbackOperation';
import ContributionModal from 'modules/_shared/components/Modals/Contribution';
import RenumerationModal from 'modules/_shared/components/Modals/Renumeration';
import Split from 'modules/_shared/components/Modals/Split';

import { ContributionModalProvider } from 'modules/_shared/components/Modals/Contribution/context/ContributionModalContext';
import InformationalModal from 'modules/_shared/components/Modals/InformationalModal';
import { InformationalModalProvider } from 'modules/_shared/components/Modals/InformationalModal/context/InformationalModalContext';
import CanjeModalWithProvider from 'modules/_shared/components/Modals/CanjeModal/CanjeModalWithProvider';
import { AddPartnerModalProvider } from 'modules/_shared/components/Modals/AddPartnerModal/context/AddPartnerModalContext';
import { CapitalDecreaseModalProvider } from 'modules/_shared/components/Modals/CapitalDecreaseModal/context/CapitalDecreaseModalContext';
import { SharesTransferModalProvider } from 'modules/_shared/components/Modals/SharesTransfer/context/SharesTransferModalContext';
import { RenumerationModalProvider } from 'modules/_shared/components/Modals/Renumeration/context/RenumerationModalContext';
import { RollbackOperationModalProvider } from 'modules/_shared/components/Modals/RollbackOperation/context/RollbackOperationModalContext';
import { DividendsDistributionModalProvider } from 'modules/_shared/components/Modals/DividendsDistribution/context/DividendsDistributionModalContext';
import { ReclassificationModalProvider } from 'modules/_shared/components/Modals/ReclassificationModal/context/ReclassificationModalContext';
import { SplitModalProvider } from 'modules/_shared/components/Modals/Split/context/SplitModalContext';
import { ConstitutionModalProvider } from 'modules/_shared/components/Modals/Constitution/context/ConstitutionModalContext';
import { CapitalIncreaseModalProvider } from 'modules/_shared/components/Modals/CapitalIncrease/context/CapitalIncreaseModalContext';
import isSuperAdmin from 'utils/isSuperAdmin';

const openSharesTransferModal = (operationType) =>
  store.dispatch(
    setModal(
      <SharesTransferModalProvider operationType={operationType}>
        <SharesTransferModal />
      </SharesTransferModalProvider>
    )
  );

const menuOptions = (i18n, user) => [
  {
    icon: 'ni-info',
    text: i18n.t('NewPartner'),
    type: operationTypes.ADD_PARTNER,
    action: () => {
      store.dispatch(
        setModal(
          <AddPartnerModalProvider>
            <AddPartnerModal />
          </AddPartnerModalProvider>
        )
      );
    },
  },
  {
    icon: 'ni-book-read',
    text: i18n.t('Constitution'),
    type: operationTypes.CONSTITUTION,
    action: () => {
      store.dispatch(
        setModal(
          <ConstitutionModalProvider>
            <Constitution />
          </ConstitutionModalProvider>
        )
      );
    },
  },
  {
    icon: 'ni-book-read',
    text: i18n.t('CapitalExpansion'),
    type: operationTypes.CAPITAL_INCREASE,
    action: () => {
      store.dispatch(
        setModal(
          <CapitalIncreaseModalProvider>
            <CapitalIncrease />
          </CapitalIncreaseModalProvider>
        )
      );
    },
  },
  {
    icon: 'ni-book-read',
    text: i18n.t('CapitalReduction'),
    type: operationTypes.CAPITAL_DECREASE,
    action: () => {
      store.dispatch(
        setModal(
          <CapitalDecreaseModalProvider>
            <CapitalDecreaseModal />
          </CapitalDecreaseModalProvider>
        )
      );
    },
  },
  {
    icon: 'ni-book-read',
    text: i18n.t('SaleOfShares'),
    type: operationTypes.SELL_PARTICIPATION,
    action: () => openSharesTransferModal(operationTypes.SELL_PARTICIPATION),
  },
  {
    icon: 'ni-book-read',
    text: i18n.t('Heritage'),
    type: operationTypes.HERITAGE,
    action: () => openSharesTransferModal(operationTypes.HERITAGE),
  },
  {
    icon: 'ni-book-read',
    text: i18n.t('Donation'),
    type: operationTypes.DONATION,
    action: () => openSharesTransferModal(operationTypes.DONATION),
  },
  {
    icon: 'ni-book-read',
    text: i18n.t('Endorsement'),
    type: operationTypes.ENDORSEMENT,
    action: () => openSharesTransferModal(operationTypes.ENDORSEMENT),
  },
  {
    icon: 'ni-book-read',
    text: i18n.t('Transmission'),
    type: operationTypes.TRANSMISSION,
    action: () => openSharesTransferModal(operationTypes.TRANSMISSION),
  },
  {
    icon: 'ni-book-read',
    text: i18n.t('Split'),
    type: operationTypes.SPLIT,
    action: () => {
      store.dispatch(
        setModal(
          <SplitModalProvider>
            <Split />
          </SplitModalProvider>
        )
      );
    },
  },
  {
    icon: 'ni-book-read',
    text: i18n.t('Renumeration'),
    type: operationTypes.RENUMERATION,
    action: () => {
      store.dispatch(
        setModal(
          <RenumerationModalProvider>
            <RenumerationModal />
          </RenumerationModalProvider>
        )
      );
    },
  },
  {
    icon: 'ni-book-read',
    text: i18n.t('Reclassification'),
    type: operationTypes.RECLASSIFICATION,
    action: () => {
      store.dispatch(
        setModal(
          <ReclassificationModalProvider>
            <Reclassification />
          </ReclassificationModalProvider>
        )
      );
    },
  },
  {
    icon: 'ni-book-read',
    text: i18n.t('DividendsDistribution'),
    type: operationTypes.DIVIDENDS_DISTRIBUTION,
    action: () => {
      store.dispatch(
        setModal(
          <DividendsDistributionModalProvider>
            <DividendsDistribution />
          </DividendsDistributionModalProvider>
        )
      );
    },
  },
  {
    icon: 'ni-book-read',
    text: i18n.t('OtherContributions'),
    type: operationTypes.CONTRIBUTION,
    action: () => {
      store.dispatch(
        setModal(
          <ContributionModalProvider>
            <ContributionModal />
          </ContributionModalProvider>
        )
      );
    },
  },
  {
    icon: 'ni-book-read',
    text: i18n.t('ExchangeOperation'),
    type: 'EXCHANGE',
    action: () => {
      store.dispatch(setModal(<CanjeModalWithProvider size={sizes.XL} />));
    },
    disabled: !isSuperAdmin(user),
  },
  {
    icon: 'ni-book-read',
    text: i18n.t('InformationalOperation'),
    type: operationTypes.INFORMATIONAL,
    action: () => {
      store.dispatch(
        setModal(
          <InformationalModalProvider>
            <InformationalModal />
          </InformationalModalProvider>
        )
      );
    },
    disabled: !isSuperAdmin(user),
  },
  {
    icon: 'ni-undo',
    text: i18n.t('RollbackOperation'),
    type: operationTypes.ROLLBACK,
    action: () => {
      store.dispatch(
        setModal(
          // @ts-ignore
          <RollbackOperationModalProvider size={sizes.XS}>
            <RollbackOperationModal />
          </RollbackOperationModalProvider>
        )
      );
    },
    borderTop: true,
  },
];

export default menuOptions;
